export default {
  sections: {
    title: 'Seções',
    noContent: 'Não há conteúdo para listar',
    seeAll: 'Ver todas'
  }
}
